<template>
  <div class="bb-timer-modal-body">
    <div class="bb-timer-modal-body__counter">
      <BBTimerModalPanel
        v-if="isTimer"
        :comment="valueObj.textAreaModel.comment"
        :body="body"
        :isError.sync="isError"
      />
      <BBTimerModalManual
        v-else
        :isSave="isSave"
        :body="body"
        :day="valueObj.calendarModel"
        :isSubproject="isSubproject"
        :isHourProject="isSubproject"
      />
    </div>
    <div
      v-if="selectSettings.isHide"
      class="bb-timer-modal-body-item"
    >
      <div class="bb-timer-modal-body__title">
        {{ selectSettings.title }}
      </div>
      <BBSelectInput
        :input="selectSettings"
        :model="valueObj"
        @input="onChangeSelectSubproject"
      />
    </div>
    <div class="bb-timer-modal-body-item">
      <div class="bb-timer-modal-body__title">
        {{ textAreaSettings.title }}
      </div>
      <BBTextarea
        :input="textAreaSettings"
        :model="valueObj.textAreaModel"
        @input="onChangeTextarea"
      />
    </div>
    <BBCheckbox
      class="bb-timer-modal-body__checkbox"
      checkboxText="Add to History Tab of Clients"
     :value="valueObj.clientIsTab"
     @checkboxChange="onChangeClientTab"
    />
    <div class="bb-timer-modal-body-company">
      <BBCheckbox
        checkboxText="Add to History Tab of Company"
        :value="valueObj.companyIsTab"
        @checkboxChange="onChangeCompanyTab"
      />
      <div
        v-for="(item, index) in valueObj.companies"
        class="bb-timer-modal-body-company-item"
        :key="item._id"
      >
        <span
          v-if="item.name"
          class="bb-timer-modal-body-company-item__title"
          @click="onDelete(item, index)"
        >
          {{ item.name }}
        </span>
        <div
          v-if="index === valueObj.companies.length - 1 && options.length"
          :class="[
              'bb-timer-modal-body-company__wrap',
            ]"
        >
          <div
            class="bb-timer-modal-body-company__add"
            v-html="PlusIcon()"
          />
          <BBSelectImage
            :options="options"
            label="name"
            :hideImage="true"
            @change="setSelect"
          />
        </div>
        <transition name="fade">
          <div
            v-if="selectCompanyError"
            class="bbp-timer-modal-body-company-error"
          >
            <div
              class="bbp-timer-modal-body-company-error__icon"
              v-html="ExclamationIcon()"
            />
            Company not selected
          </div>
        </transition>
      </div>
    </div>
    <div
      :class="[
        'bb-timer-modal-body__data-picker',
        isTimer && 'bb-timer-modal-body__data-picker_disabled'
      ]"
    >
      <DataPicker
        styleType="mini"
        :default-date="valueObj.calendarModel.startDate"
        :noBorder="true"
        format="DD-MMM"
        :noFuture="true"
        @setDate="onChangeDate"
      />
    </div>
  </div>
</template>

<script>
import BBCheckbox from '@/components/Main/Inputs/checkbox'
import BBTextarea from '@/components/Main/Inputs/BBTextarea'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import BBSelectInput from '@/components/Main/Form/BBSelectInput/BBSelectInput'
import BBSelectImage from '@/components/Main/Inputs/BBSelectImage'
import BBTimerModalPanel
  from '@/components/Main/TimerControl/BBTimerModal/BBTimerModalPanel/BBTimerModalPanel'
import BBTimerModalManual
  from '@/components/Main/TimerControl/BBTimerModal/BBTimerModalManual/BBTimerModalManual'
import { PlusIcon, ExclamationIcon } from '@/constants/icon'
import ContactCompanyApi from '@/api/ContactCompanies/api'

export default {
  name: 'BBPTimerModalBody',
  components: {
    BBSelectInput,
    BBSelectImage,
    BBTimerModalManual,
    BBTimerModalPanel,
    BBTextarea,
    DataPicker,
    BBCheckbox
  },
  props: {
    isTimer: {
      type: Boolean,
      default: true
    },
    activeTimer: {
      type: Object,
      default: () => ({})
    },
    isSave: {
      type: Boolean,
      default: false
    },
    isErrorComment: {
      type: Boolean,
      default: false
    },
    isErrorSelect: {
      type: Boolean,
      default: false
    },
    body: {
      type: Object,
      default: () => ({})
    },
    isSubproject: {
      type: Boolean,
      default: false
    },
    isHourProject: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    textAreaSettings: {
      model: 'comment',
      title: 'Comment',
      height: '115px',
      placeholder: 'Enter a comment',
      isError: false
    },
    selectSettings: {
      title: 'Subproject',
      model: 'subprojectId',
      placeholder: 'No entries',
      disabled: false,
      isHide: false,
      options: []
    },
    valueObj: {
      clientIsTab: false,
      companyIsTab: true,
      calendarModel: {
        startDate: new Date()
      },
      textAreaModel: {
        comment: ''
      },
      subprojectId: undefined,
      companies: [{}]
    },
    isError: false,
    options: [],
    PlusIcon,
    ExclamationIcon
  }),
  computed: {
    selectCompanyError: {
      get () {
        return this.isErrorSelect
      },
      set (data) {
        this.$emit('update:isErrorSelect', data)
      }
    },
    error: {
      get () {
        return this.isErrorComment
      },
      set (data) {
        this.$emit('update:isErrorComment', data)
      }
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    },
    activeTimerStatus () {
      const { subTimers = {} } = this.activeTimer
      const { status = 4 } = subTimers
      return status
    }
  },
  methods: {
    onChangeClientTab (value) {
      this.valueObj = {
        ...this.valueObj,
        clientIsTab: value
      }
    },
    onChangeCompanyTab (value) {
      this.selectCompanyError = false
      this.valueObj = {
        ...this.valueObj,
        companyIsTab: value
      }
    },
    onChangeDate (date) {
      this.valueObj = {
        ...this.valueObj,
        calendarModel: {
          startDate: date
        }
      }
    },
    onChangeTextarea (comment) {
      this.valueObj = {
        ...this.valueObj,
        textAreaModel: {
          comment
        }
      }
    },
    setSelect (value) {
      this.selectCompanyError = false
      const { companies } = this.valueObj
      const [firstItem] = companies

      this.valueObj = {
        ...this.valueObj,
        companies: Object.keys(firstItem).length ? [...companies, value] : [value]
      }
      const currentIndex = this.options.findIndex(({_id}) => _id === value._id)
      this.options.splice(currentIndex, 1)
    },
    createDefaultValue () {
      const { subTimers = {}, subprojectId, subProjectsList = [] } = this.activeTimer
      const { comment, companyIsTab, clientIsTab, companies = [] } = subTimers
      this.valueObj = {
        ...this.valueObj,
        companyIsTab,
        clientIsTab,
        subprojectId: subProjectsList.find((el) => el.id === subprojectId),
        textAreaModel: {
          comment
        },
        companies: companies.length ? companies : [{}]
      }
      this.selectSettings.isHide = subprojectId
      this.selectSettings.options = subProjectsList
    },
    onDelete (item, index) {
      this.valueObj.companies.splice(index, 1)
      if (this.valueObj.companies.length === 0) {
        this.valueObj.companies.push({})
      }
      this.options.unshift(item)
    },
    async getCompanies () {
      const { client } = this.activeTimer
      const body = {
        limit: 9999,
        page: 1,
        client
      }
      try {
        const { data } = await ContactCompanyApi.getContactCompanies(body)
        const { clientcompanies = [] } = data
        this.options = JSON.parse(JSON.stringify(clientcompanies))
        this.clientCompanies = clientcompanies
        this.setDefaultCompany()
      } catch (err) {
        console.error(err)
      }
    },
    setDefaultCompany () {
      this.valueObj.companies.forEach((el) => {
        const currentIndex = this.options.findIndex(({_id}) => _id === el._id)
        if (currentIndex === -1) return
        this.options.splice(currentIndex, 1)
      })
    },
    onChangeSelectSubproject ({ id }) {
      this.activeTimer.subprojectId = id
    }
  },
  watch: {
    isSave () {
      this.options = [...this.clientCompanies]
    },
    isError (newVal) {
      this.textAreaSettings.isError = newVal
    },
    error (newVal) {
      this.textAreaSettings.isError = newVal
    },
    'valueObj.textAreaModel.comment' (newVal) {
      if (newVal) {
        this.textAreaSettings.isError = false
        this.error = false
      }
    },
    valueObj: {
      handler (newValue) {
        const { clientIsTab, companyIsTab, textAreaModel = {}, companies = [] } = newValue
        const { comment } = textAreaModel
        const body = {
          clientIsTab,
          companyIsTab,
          comment,
          companies: companyIsTab ? companies.map((el) => el._id) : []
        }
        this.$emit('update:body', body)
      },
      deep: true
    }
  },
  beforeMount () {
    this.createDefaultValue()
    const [firstItem = {}] = this.clientCompanies
    const { client: firstItemClient = {} } = firstItem
    const { id } = firstItemClient
    const { client = {} } = this.activeTimer
    if (this.clientCompanies.length && id === client._id) {
      this.options = [...this.clientCompanies]
      this.setDefaultCompany()
    } else {
      this.getCompanies()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-timer-modal-body {

    &__title {
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
      margin: 0 0 8px 0;
    }

    &__counter {
      margin: 20px 0 20px 0;
      height: 36px;
    }

    &__checkbox {
      margin: 0 0 11px 0;
    }

    &__data-picker {
      margin: 20px 0 0 0;
      width: max-content;
    }
  }

  .bb-timer-modal-body-item {
    margin: 0 0 12px 0;
  }

  .bb-timer-modal-body-company {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    grid-gap: 10px 0;

    &__wrap {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      position: relative;

      &_disabled {
        pointer-events: none;
      }
    }

    &__add {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: $color-wild-sand;

      &:hover {
        opacity: 0.8;
        transition: 0.2s;
        cursor: pointer;
      }
    }
  }

  .bb-timer-modal-body-company-item {
    display: flex;
    align-items: center;

    &__title {
      font-weight: 400;
      line-height: 17px;
      font-size: 14px;
      color: $color-denim;
      margin: 0 6px 0 0;
      transition: 0.2s;

      &:hover {
        opacity: 0.8;
        cursor: pointer;
      }
    }
  }

.bbp-timer-modal-body-company-error {
  display: flex;
  align-items: center;
  grid-gap: 0 4px;
  margin: 0 0 0 10px;
  color: $color-pomegranate;
  font-size: 13px;

  &__icon {
    display: flex;
  }
}
</style>

<style lang="scss">
@import "../../../../sass/variables";

   .bb-timer-modal-body {

      .bb-checkbox-container__checkmark-wrapper {
        width: 15px !important;
        height: 15px !important;
      }

      .bb-checkbox__text {
        margin-left: 9px !important;
        margin-right: 6px !important;
        font-size: 14px !important;
      }

       &__data-picker_disabled {

         .bb-data-picker-wrapper {
           pointer-events: none;
         }

         .bb-data-picker__input_mini {
           color: $color-silver !important;
         }

         .bb-data-picker__icon_mini {
           color: $color-silver !important;
         }
       }
   }

  .bb-timer-modal-body-company .bb-loader-select-header {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TimerControl/BBTimerModal/BBTimerModalBody.vue